import React from "react";
import ReactDOM from "react-dom/client";
import Modal from "react-modal";
import "./i18n";

import App from "./App";

import "flag-icons";

import "./index.css";

Modal.setAppElement("#root");

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
